import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import windowSize from 'react-window-size';
// COMPONENTS
import Row from 'components/common/Row';
import Steps from 'components/common/Steps';
import Col from 'components/common/Col';
import Icon from 'components/common/Icon';

const TopRowContainer = styled(Row)`
  border-bottom: 2px solid #efefef;
  height: 70px;
  background: #fff;
  padding: 0px;
`;

const StepContainer = styled.div`
  max-width: 100%;
  @media (max-width: 480px) {
    .ant-steps-horizontal.ant-steps-label-horizontal {
      display: flex;
    }
  }
`;

const ContractsLink = ({ currentUser, windowWidth }) => {
  if (currentUser) {
    return (
      <Link to="/app" style={{ fontSize: 17, color: '#999' }}>
        <Icon type="left" />
        {windowWidth > 780 && <span>HOME</span>}
      </Link>
    );
  }
  return null;
};

const { Step } = Steps;

// https://app.hellobonsai.com/c/a80fc561-ef71-44d2-9cf2-e784acaa756a?utm_campaign=signing&utm_content=contract_to_contact_to_sign&utm_source=email
class InvoicePageHeader extends React.Component {
  render() {
    let bigWindow = this.props.windowWidth > 780;
    return (
      <StepContainer>
        <TopRowContainer>
          <Col xs={2} sm={4} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <ContractsLink {...this.props} />
          </Col>
          {/* <Col xs={4} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} /> */}
          <Col xs={0} sm={1} />
          <Col xs={20} sm={12}>
            <Steps current={this.props.current}>
              <Step title={bigWindow ? 'CREATE' : null} icon={<Icon type="bars" />} />
              <Step title={bigWindow ? 'REVIEW' : null} icon={<Icon type="copy" />} />
              <Step title={bigWindow ? 'SEND' : null} icon={<Icon type="mail" />} />
            </Steps>
          </Col>
          <Col xs={0} sm={1} />
          <Col xs={0} sm={4} />
        </TopRowContainer>
      </StepContainer>
    );
  }
}

export default InvoicePageHeader;



// WEBPACK FOOTER //
// ./src/routes/invoice-create/InvoicePageHeader/index.js